<template>
  <div class="order-details">
    <div class="top" @click="back">
      <img
        src="https://img.yzcdn.cn/upload_files/2020/08/31/FqcC4dmwQzaB9o500ZpVDJqLKIQj.png"
      />返回
    </div>
    <div class="details-main">
      <div class="order-info">
        <div class="order-top">
          <div class="cover">
            <img
              :src="
                workbooks.picurl
                  ? this.$env.ossUrl(workbooks.picurl)
                  : this.$env.ossUrl(workbooks.workbookPicurl)
              "
            />
          </div>
          <div class="detail">
            <div class="name">
              {{ workbooks.name || workbooks.workbookName || '' }}
            </div>
            <div class="money">
              <div>
                <span>¥</span>
                {{
                  transPrice(workbooks.price * 0.01 || workbooks.workbookPrice * 0.01 || '', false)
                }}
              </div>
              <div class="num">x{{ workbooks.num || 1 }}</div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="c-m-bottom">
            <div class="time-data">有效期</div>
            <div>购买日起1个月内有效</div>
          </div>
          <div class="c-m-bottom mt">
            <div class="time-data msg">温馨提示</div>
            <div>购买后不可退订</div>
          </div>
        </div>
      </div>
      <div class="price flex-space ">
        <div class="left">共{{ workbooks.num || 1 }}件商品</div>
        <div class="right">
          小计：¥<span>{{
            transPrice(workbooks.price * 0.01 || workbooks.workbookPrice * 0.01 || '', false)
          }}</span>
        </div>
      </div>
    </div>
    <van-radio-group v-model="radio" class="radio-group ">
      <van-cell-group>
        <van-cell title="微信支付" clickable class="title-1" @click="radio = '1'">
          <template #right-icon>
            <div v-if="$env.isIos" class="tip">
              *仅支持安卓手机帮你代付
            </div>
            <van-radio name="1" icon-size="20px" checked-color="#FF2638" />
          </template>
        </van-cell>
        <!--        <van-cell-->
        <!--          title="600移动积分兑换"-->
        <!--          clickable-->
        <!--          class="title-2"-->
        <!--          @click="checkBindPhoneThenPopup"-->
        <!--        >-->
        <!--          <template #right-icon>-->
        <!--            <span class="yd">移动用户专享</span>-->
        <!--            <van-radio name="2" icon-size="20px" checked-color="#FF2638" />-->
        <!--          </template>-->
        <!--        </van-cell>-->
      </van-cell-group>
    </van-radio-group>

    <!-- 苹果按钮 -->
    <div v-if="$env.isIos">
      <div v-if="radio == '1'" class="order-pay flex-space">
        <div>
          共1件，<span>总计：¥ {{ transPrice(totalPrice) }}</span>
        </div>
        <div v-if="hasOrder && ishavedaiFu && !daiFuTimeEnd" class="btn" @click="daiFu()">
          <div class="time-s">代付剩余时间</div>
          <div>
            <van-count-down
              ref="countDown"
              :time="time"
              format="mm分ss秒"
              @finish="() => (daiFuTimeEnd = true)"
            />
          </div>
        </div>
        <div v-else class="btn" @click="daiFu()">找人代付</div>
      </div>
      <div v-if="radio == '2'" class="order-pay flex-space">
        <div>共1件，<span>总计：¥ 600积分</span></div>
        <div
          v-trackevent="{
            type: 'funcTracker',
            action: 'click',
            opt_label: '立即兑换1'
          }"
          class="btn"
          @click="inTegral()"
        >
          立即兑换
        </div>
      </div>
    </div>
    <!-- 安卓按钮 -->
    <div v-else class="order-pay flex-space">
      <div>
        <div>共1件</div>
        <span>总计：¥ {{ transPrice(totalPrice) }}</span>
      </div>
      <div v-if="radio == '1'">
        <div v-if="hasOrder && !timeEnd" class="az-btns">
          <div class="btns" @click="daiFu()">
            <div class="btns sm" @click="daiFu()">找人代付</div>
          </div>
          <div class="btns red">
            <div class="time-s" @click="createOrder(false)">支付剩余时间</div>
            <div>
              <van-count-down
                ref="countDown"
                :time="time"
                format="mm分ss秒"
                @finish="() => (timeEnd = true)"
              />
            </div>
          </div>
        </div>
        <div v-else class="az-btns">
          <div class="btns sm" @click="daiFu()">找人代付</div>
          <div class="btns red sm" @click="createOrder(false)">立即支付</div>
        </div>
      </div>
      <div v-if="radio == '2'" class="order-pay flex-space paddinglist">
        <div>
          <div>共1件</div>
          <span>总计：600积分</span>
        </div>
        <div class="az-btns">
          <div class="btns sm" style="background: #F5F5F5;color: #CDCCCC;">找人代付</div>
          <div
            v-trackevent="{
              type: 'funcTracker',
              action: 'click',
              opt_label: '立即兑换1'
            }"
            class="btns red sm"
            @click="inTegral()"
          >
            立即兑换
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Orderspopput from '../component/overlay'
import { timestamp, format, transPrice } from '@/static/js/zjs.js'
import { getLuckyDrawfindActivity } from '@/api/luckyDraw'
import { open } from '@/plugin/popup'
import { CountDown, Toast, RadioGroup, Radio, Cell, CellGroup, Dialog } from 'vant'
export default {
  name: '',
  components: {
    [CountDown.name]: CountDown,
    [RadioGroup.name]: RadioGroup,
    [Dialog.name]: Dialog,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
    // Orderspopput
  },
  data() {
    return {
      radio: '1',
      hasOrder: false,
      reveal: false,
      workbooks: {}, // 书籍基本信息
      totalPrice: '',
      time: '', // 剩余时间
      timeEnd: false, // 立即支付倒计时结束
      orderStatus: '',
      paying: false,
      payOrderId: '', // 订单的id
      ishavedaiFu: false, // 是否是代付订单
      haveOrder: false, // 是否存在待兑换订单
      daiFuTimeEnd: false // 代付倒计时结束
    }
  },
  computed: {
    mobile() {
      return this.$store.userInfo.mobile
    }
  },
  watch: {
    $route: {
      handler(news, lods) {},
      deep: true
    }
  },
  mounted() {
    this.checkHaveOrder()
  },
  methods: {
    transPrice,
    format,
    back() {
      this.$router.back()
    },
    async checkBindPhoneThenPopup() {
      try {
        const status = await this.$http.post(
          `/cms/weixin/sendSMS/checkPhoneNum?openid=${this.$store.userInfo.openid}`
        )
        const { code, isNeedUnbind } = status.data
        if (code === 201 && isNeedUnbind) {
          // 当前用户手机号绑定了多个账号
          open({
            name: 'BindPhone',
            options: {
              type: 4
            },
            expired: false
          })
          this.radio = '1'
          return
        } else if (!this.mobile) {
          this.$trackevent({
            type: 'funcTracker',
            action: 'show',
            opt_label: '积分兑换绑手机号弹窗_'
          })
          open({
            name: 'BindPhone',
            options: {
              type: 3
            },
            expired: false
          })
          this.radio = '1'
          return
        }
        this.radio = '2'
      } catch (e) {}
    },
    // 立即兑换
    Coversion() {
      this.reveal = true
    },
    // 查询是否有未支付订单
    checkHaveOrder(orderId) {
      const { id, order_id } = this.$route.query
      const orderId_real = orderId || order_id
      let params
      if (id) {
        params = {
          openid: this.$store.openid,
          ids: [
            {
              id: this.$route.query.id,
              num: 1
            }
          ]
        }
      }
      if (orderId_real) {
        params = {
          openid: this.$store.openid,
          payOrderId: orderId_real
        }
      }
      this.$http.post('/cms/weixin/user/book/order/checkHaveOrder', params).then((res) => {
        if (res.data && res.data.payOrder) {
          this.orderStatus = 'old'
          this.hasOrder = true
          this.workbooks = res.data.payOrder.payOrderGoods[0]
          this.ishavedaiFu = res.data.payOrder.payAnotherRecordId // 存在代付
          // 倒计时时间差30分钟
          var createTime = new Date(res.data.payOrder.createtime.replace(/-/g, '/')).getTime()
          // ios不支持new Date('2020-01-01')形式  转化为new Date('2020/01/01')
          this.timeEnd = false
          this.time = new Date(createTime).valueOf() + 30 * 60 * 1000 - timestamp()

          this.$nextTick(() => {
            this.$refs.countDown.reset()
            this.$refs.countDown.start()
          })
        } else {
          this.orderStatus = 'create'
          this.workbooks = res.data.workbooks[0]
        }
        this.totalPrice = res.data.totalPrice
      })
    },
    // 直接付款 直接支付
    createOrder() {
      if (this.paying) {
        return
      }
      const { isdeleted, status } = this.workbooks
      if (isdeleted === 'Y') {
        Toast('该书籍已删除，无法订阅')
        return
      }
      if (status && status !== 2) {
        Toast('该书籍已下线，无法订阅')
        return
      }
      this.paying = true
      var payOrderId = this.workbooks.payOrderId || this.$route.query.order_id || ''
      var params = {
        openid: this.$store.openid,
        channel: this.$route.query.channel || 'db_ymy_n_gn',
        body: this.workbooks.name || this.workbooks.workbookName || ''
      }
      if (this.orderStatus === 'create') {
        params.ids = [
          {
            id: this.$route.query.id || this.workbooks.id,
            num: 1
          }
        ]
      } else {
        params.payOrderId = payOrderId
      }
      this.$http.post('/cms/weixin/user/book/order/create', params).then((res) => {
        if (res.data) {
          this.payOrderId = res.data.payOrderId
          setTimeout(() => {
            this.paying = false
          }, 1000)
          window.wx.chooseWXPay({
            appId: res.data.appId,
            timestamp: res.data.timeStamp,
            nonceStr: res.data.nonceStr,
            package: res.data.wxpackage,
            signType: res.data.signType,
            paySign: res.data.paySign,
            success: (res) => {
              if (res.errMsg === 'chooseWXPay:ok') {
                this.winSuccse(this.payOrderId)
              } else {
                alert('支付失败:' + res.errMsg + '\n您可以重试或在客服留言咨询.')
              }
            },
            cancel: () => {
              this.checkHaveOrder(res.data.payOrderId)
            }
          })
        } else {
          Toast({ duration: 3000, message: '系统犯晕中，休息一下\n重新打开页面试试吧～' })
        }
      })
    },
    async winSuccse(payOrderId) {
      var params = {
        openid: this.$store.openid,
        payOrderId
      }
      await getLuckyDrawfindActivity(params).then((res) => {
        if (res.data.status === 200) {
          window.location.href = '/cms/webapp/home/activities/#/luckyDraw?payOrderId=' + payOrderId
          return
        }
        window.location.replace(
          `/cms/webapp/home/answer/index.html#/bookPaySuc?order_id=${payOrderId}`
        )
      })
    },
    // 代付
    daiFu() {
      const { isdeleted, status } = this.workbooks
      if (isdeleted === 'Y') {
        Toast('该书籍已删除，无法订阅')
        return
      }
      if (status && status !== 2) {
        Toast('该书籍已下线，无法订阅')
        return
      }
      this.$router.push({
        path: 'cerateDaiFu',
        query: {
          id: this.$route.query.id
        }
      })
    },
    // 查询图书状态
    bookStatus() {
      const { isdeleted, status } = this.workbooks
      if (isdeleted === 'Y') {
        Toast('该书籍已删除，无法订阅')
        return
      }
      if (status && status !== 2) {
        Toast('该书籍已下线，无法订阅')
        return
      }
    },
    // 积分兑换
    inTegral() {
      this.$http
        .post(
          '/cms/weixin/user/book/order/checkHaveCmccOrder?mobile=' +
            this.mobile +
            '&checkStatus=' +
            true
        )
        .then((res) => {
          if (res.data.code === 101) {
            this.$router.push({
              path: 'IntegralGraphicMaintain'
            })
            return
          }
          if (res.data.haveOrder) {
            Dialog.confirm({
              title: '是否确认兑换当前练习册?',
              message: '之前待兑换订单将会失效',
              confirmButtonColor: '#EF4246',
              width: '7.6rem'
            })
              .then(() => {
                this.inTegralDingdan()
              })
              .catch((e) => {})
          } else {
            this.inTegralDingdan()
          }
        })
    },
    inTegralDingdan() {
      this.bookStatus()
      // var payOrderId = this.workbooks.payOrderId || this.$route.query.order_id || ''
      var params = {
        openid: this.$store.openid,
        channel: this.$route.query.channel || 'db_ymy_n_gn',
        body: this.workbooks.name || this.workbooks.workbookName || ''
      }
      params.ids = [
        {
          id: this.$route.query.id || this.workbooks.id,
          num: 1
        }
      ]
      this.$http.post('/cms/weixin/user/book/order/createCmccScore', params).then((res) => {
        if (res.data) {
          this.$trackevent({
            type: 'funcTracker',
            action: 'show',
            opt_label: '积分兑换页面'
          })
          this.$router.push({
            path:
              'IntegralGraphic?channel=' + this.$route.query.channel + '&id=' + this.$route.query.id
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scope>
.order-details {
  background: #f6f6f6;
  height: 100vh;
  margin-bottom: 34px;
  .flex-space {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .top {
    display: flex;
    align-items: center;
    background: #fff;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
    height: 40px;
    padding-left: 21px;
    img {
      width: 10px;
      margin-right: 12px;
    }
  }
  .details-main {
    padding: 16px 16px 8px;
  }
  .order-info {
    height: 210px;
    background: #ffffff;
    border-radius: 4px;
    padding: 14px 12px 14px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .order-top {
      display: flex;
      border-bottom: 0.5px solid #f5f5f5;
      padding-bottom: 14px;
      .cover {
        width: 72px;
        height: 102px;
        border-radius: 4px;
        margin-right: 8px;
        img {
          width: 100%;
          border-radius: 4px;
        }
      }
      .detail {
        flex: 1;
        font-weight: normal;
        font-size: 14px;
        color: #333333;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .name {
          width: 239px;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          color: #333333;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .money {
          font-size: 14px;
          color: #333333;
          display: flex;
          justify-content: space-between;
          span {
            font-size: 12px;
          }
          .num {
            color: #333333;
          }
        }
      }
    }

    .c-m-bottom {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #333333;
      .time-data {
        width: 46px;
        height: 20px;
        background: rgba(73, 113, 255, 0.15);
        border-radius: 2px;
        color: #4971ff;
        font-size: 11px;
        text-align: center;
        line-height: 20px;
        &.msg {
          width: 56px;
          background: rgba(255, 129, 38, 0.15);
          color: #ff8126;
        }
      }

      &.mt {
        margin-top: 12px;
        .num {
          font-size: 12px;
          color: #ff2638;
          span {
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
      div {
        line-height: 1;
      }
      span {
        font-size: 18px;
        margin-left: 4px;
      }
    }
  }
  .price {
    height: 58px;
    background-image: url('https://img.yzcdn.cn/upload_files/2020/09/01/ForQ3BOYe0vGF7b1rK8PjpIoDzBK.png');
    background-size: 100% 100%;
    padding: 0 18px 0 12px;
    .left {
      font-size: 12px;
      line-height: 12px;
      color: #999999;
    }
    .right {
      font-size: 12px;
      color: #333333;
      .youhui {
        display: inline-block;
        margin-right: 7px;
        span {
          font-size: 12px;
          color: #ff2638;
        }
      }
      span {
        font-size: 16px;
        font-weight: 500;
        margin-left: 2px;
      }
    }
  }

  .order-pay {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 78px;
    background: #ffffff;
    font-size: 16px;
    color: #666666;
    padding: 0 16px;
    // .youhui {
    //   text-align: right;
    //   font-size: 12px;
    //   color: #ff2638;
    //   margin-top: 2px;
    // }
    span {
      color: #ff2638;
      font-weight: 500;
    }
    .az-btns {
      flex: 1;
      display: flex;
      justify-content: flex-end;
    }
    .btn {
      width: 152px;
      height: 50px;
      color: #fff;
      background: #ff2638;
      border-radius: 25px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .time-s {
        font-size: 12px;
      }
      .van-count-down {
        font-weight: 500;
        font-size: 14px;
        color: #fff;
      }
    }
    .btns {
      width: 110px;
      height: 44px;
      background: #ffb028;
      border-radius: 1rem 0rem 0rem 1rem;
      font-size: 12px;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &.sm {
        font-size: 16px;
      }
      .van-count-down {
        color: #fff;
      }
      .no-time {
        font-size: 16px;
      }
      &.red {
        background: #ff2638;
        border-radius: 0rem 1rem 1rem 0rem;
      }
    }
  }
  .paddinglist {
    padding: 0;
    padding-right: 27px;
  }
  .radio-group {
    margin: 0 auto;
    background: #ffffff;
    border-radius: 4px;
    width: 343px;
    padding: 0 18px;
    .yd {
      display: inline-block;
      border: 1px solid #ff2638; /*no*/
      box-sizing: border-box;
      border-radius: 3px;
      height: 18px;
      font-size: 10px;
      line-height: 18px;
      color: #ff2638;
      position: absolute;
      right: 33px;
      top: 50%;
      transform: translateY(-50%);
      text-align: center;
      padding: 0 8px;
    }
    .van-cell {
      padding: 0;
      height: 66px;
      line-height: 66px;
      background: #fff;
    }
    img {
      width: 26px;
    }
    .title-1,
    .title-2 {
      font-size: 16px;
      color: #333333;
    }
    .title-1 {
      .van-cell__title {
        margin-top: -6px;
      }
    }
    .title-1::before {
      content: '';
      display: inline-block;
      width: 26px;
      height: 26px;
      background: url('https://img.yzcdn.cn/upload_files/2020/10/12/Fhwim48sQSmUYaQqcdq-gaBb5owN.png');
      background-size: 100% 26px;
      background-repeat: no-repeat;
      position: relative;
      top: 18px;
      margin-right: 10px;
    }
    .title-2::before {
      content: '';
      display: inline-block;
      width: 26px;
      height: 26px;
      background: url('https://img.yzcdn.cn/upload_files/2020/10/12/FvWAT16AL848rskev8yeDOU7zI3a.png');
      background-size: 100% 26px;
      background-repeat: no-repeat;
      position: relative;
      top: 18px;
      margin-right: 10px;
    }
  }
  [class*='van-hairline']::after {
    border: none;
  }
  .tip {
    font-size: 12px;
    color: #999999;
    position: absolute;
    margin-top: 16px;
    margin-left: 32px;
  }
}
</style>
